import { type FormEvent, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/Button';
import { Input } from '@/components/ui/Input';
import { AuthShell } from '@/components/shared/Placeholders';
import { ROUTES } from '@/constants/routes';
import { useAdminAuth } from '@/context/AdminAuthContext';

export function AdminLoginPage() {
  const navigate = useNavigate();
  const { login, isLoading, clearError } = useAdminAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    clearError();
    try {
      await login({ email, password });
      navigate(ROUTES.adminRoot);
    } catch {
      // handled in context
    }
  }

  return (
    <AuthShell
      title="Admin sign in"
      subtitle="Platform administration access only"
      loading={isLoading}
      loadingLabel="Signing in..."
      footer={
        <Link to={ROUTES.home} className="hover:text-primary">
          ← Back to website
        </Link>
      }
    >
      <form onSubmit={(e) => void handleSubmit(e)} className="space-y-4">
        <Input label="Admin email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
        <Input label="Password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
        <Button type="submit" fullWidth loading={isLoading} loadingText="Signing in...">
          Sign in to admin
        </Button>
      </form>
    </AuthShell>
  );
}
